import { createFileRoute } from '@tanstack/react-router'

import { NavigationPage } from '@/features/navigation'

export const Route = createFileRoute('/_authenticated/_main/mais')({
  component: NavigationPage
})
